<div [formGroup]="parentForm" *ngIf="parentForm.get(controlName)">
  <div class="form-row" style="flex-basis: 100%" [formGroupName]="controlName">
    <ng-container *ngFor="let control of jsonFormData">
      <ng-container [ngSwitch]="control.fieldType">
        <ng-container *ngSwitchCase="'cardTitle'">
          <h2 class="card-text-2 mt-2" [ngClass]="control.colWidth">
            {{ control.labelName }}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'checkbox'">
          <div class="form-group col" [ngClass]="control.colWidth">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="control.fieldName"
                [formControlName]="control.fieldName"
              />
              <label class="custom-control-label" [for]="control.fieldName">{{
                control.labelName
              }}</label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <div
            class="form-group col {{ control.colWidth }}"
            [ngClass]="{
              required: control?.validations?.staticValidations?.required
            }"
          >
            <label
              [for]="control.fieldName"
              [ngClass]="{
                required: control?.validations?.staticValidations?.required
              }"
              >{{ control.labelName }}</label
            >
            <ng-container
              [ngTemplateOutlet]="
                control.fieldType !== 'dropdown' ? textbox : showDropDown
              "
              [ngTemplateOutletContext]="{ control: control }"
            >
            </ng-container>
            <div
              *ngIf="
                dynamicFormControls[control.fieldName]?.dirty &&
                dynamicFormControls[control.fieldName]?.errors
              "
              class="invalid-feedback"
            >
              <div
                *ngIf="dynamicFormControls[control.fieldName]?.errors.required"
              >
                {{ control.labelName }} is required
              </div>
              <div *ngIf="dynamicFormControls[control.fieldName]?.errors.min">
                {{ control.labelName }} value should be greater than or equal to
                {{ control?.validations?.staticValidations?.min }}
              </div>
              <div *ngIf="dynamicFormControls[control.fieldName]?.errors.max">
                Please reach out to our sales team, as you reached max of
                {{ control?.validations?.staticValidations?.max | number }}
                users
              </div>
              <div
                *ngIf="
                  dynamicFormControls[control.fieldName]?.errors
                    .newUserNameIncludesPlusSign
                "
              >
                Please enter a valid {{ control.labelName | lowercase }}
              </div>
              <div
                *ngIf="
                  !dynamicFormControls[control.fieldName]?.errors
                    .newUserNameIncludesPlusSign &&
                  !dynamicFormControls[control.fieldName]?.errors.required &&
                  !dynamicFormControls[control.fieldName]?.errors
                    .duplicateName &&
                  !dynamicFormControls[control.fieldName]?.errors.min &&
                  !dynamicFormControls[control.fieldName]?.errors.max
                "
              >
                Please enter a valid {{ control.labelName | lowercase }}
              </div>
              <div
                *ngIf="
                  dynamicFormControls[control.fieldName]?.errors.duplicateName
                "
              >
                {{ control.labelName }} already exists. Please contact your
                administrator.
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #textbox let-control="control">
      <ng-container [ngSwitch]="control.fieldType">
        <ng-container *ngSwitchCase="'readonlyText'">
          <div
            class="font-weight-bolder"
            *ngIf="
              dynamicFormControls[control.fieldName].value !== 'FREE!';
              else free
            "
          >
            <span class="mr-1"></span>
            {{
              dynamicFormControls[control.fieldName].value
                | displayCurrency : displayCurrency
            }}
          </div>
          <ng-template #free>
            <div class="font-weight-bolder">
              {{ dynamicFormControls[control.fieldName].value }}
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'mask-text'">
          <input
            type="tel"
            ccNumber
            class="form-control"
            [id]="control.fieldName"
            placeholder=""
            [formControlName]="control.fieldName"
            [mask]="control.maskInput"
            [hiddenInput]="true"
            [ngClass]="{
              'is-invalid':
                dynamicFormControls[control.fieldName]?.errors &&
                dynamicFormControls[control.fieldName]?.dirty
            }"
          />
        </ng-container>
        <ng-container *ngSwitchDefault>
          <input
            (keypress)="checkKeyPress($event)"
            [type]="control.fieldType"
            [min]="control?.validations?.staticValidations?.min"
            [max]="control?.validations?.staticValidations?.max"
            class="form-control"
            [formControlName]="control.fieldName"
            [id]="control.fieldName"
            [attr.disabled]="control?.disabled"
            [required]="control?.validations?.staticValidations?.required"
            [ngClass]="{
              'is-invalid':
                dynamicFormControls[control.fieldName]?.dirty &&
                dynamicFormControls[control.fieldName]?.errors
            }"
          />
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template #showDropDown let-control="control">
      <select
        id="control.fieldName"
        class="form-control"
        [formControlName]="control.fieldName"
        [ngClass]="{
          'is-invalid':
            dynamicFormControls[control.fieldName]?.dirty &&
            dynamicFormControls[control.fieldName]?.errors
        }"
      >
        <ng-container
          [ngTemplateOutlet]="control.optionLevel === 1 ? options : optionGroup"
          [ngTemplateOutletContext]="{ control: control }"
        >
        </ng-container>
      </select>
    </ng-template>
    <ng-template #options let-control="control">
      <option value="">Select</option>

      <option
        *ngFor="let countryOptions of control.options"
        [ngValue]="countryOptions.value"
        value="{{ countryOptions.value }}"
      >
        {{ countryOptions.display }}
      </option>
    </ng-template>
    <ng-template #optionGroup let-control="control">
      <option value="">Select</option>
      <optgroup
        *ngFor="let stateOption of control.options"
        [label]="stateOption.country"
      >
        <option
          *ngFor="let state of stateOption.state"
          [ngValue]="state.abbreviation"
          value="{{ state.abbreviation }}"
        >
          {{ state.name }}
        </option>
      </optgroup>
    </ng-template>
  </div>
</div>
